import React, { useEffect, useState } from "react";
import { MdOutlineArrowBackIosNew as LBtn, MdOutlineArrowForwardIos as RBtn } from 'react-icons/md';
import { FiMoreHorizontal as MoreIcon } from 'react-icons/fi';
import tableStyle from '../css/table.module.css';
import SettingsModal from '../Modal/settingsCustomModal';
import ApplicationPeriodDetails from "./ApplicationPeriodDetails";
import { stripDateString, convertTimetoString } from "../../../../helperFunction";
import { RouteResponse } from '../../../../types/index';
import { FetchAllRoutes, reOrderFetchedData, filterRouteName } from '../../../../hooks/FetchData';
import UpdateApplicationPeriod from './UpdatePeriod'; // Ensure this is imported correctly
import { QueryClient, QueryClientProvider } from "react-query";
import { ApplicationPeriod } from '../../ApplicantDetails/type';


interface ApplicationPeriodResponse {
  StatusCode: number;
  Message: string;
  Data: ApplicationPeriod[];
}


// interface ApplicationPeriod {
//   ApplicationPeriodId: number;
//   RouteId: number;
//   RouteName: string
//   StateDate: string;
//   EndDate: string;
//   Status: boolean;
//   Year: number;
//    StatusCode: number;
//   Message: string;
//   Data: ApplicationPeriod[];
// }


interface ComponentProps {
  data: ApplicationPeriodResponse | undefined;
}
const queryClient = new QueryClient(); // Add this line


const ApplicationPeriodTable: React.FC<ComponentProps> = ({ data }) => {
  const [activeData, setActiveData] = useState<any>([]);
  const [pageData, setPageData] = useState<any>([]);
  const [currentPage, setCurrentPage] = useState<number>(0);
  const [pageArr, setPageArr] = useState<any>([]);
  const [showMore, setShowMore] = useState<boolean>(false);
  const [showIndex, setShowIndex] = useState<any>(null);
  const [showSpan, setShowSpan] = useState<boolean>(false);
  const [spanIndex, setSpanIndex] = useState<null | number>(null);
  const [StateDate, setStartDate] = useState('');
  const [routeId, setRouteId] = useState<number>(0);
  const [endDate, setEndDate] = useState('');
  const [year, setYear] = useState(0);
  const [status, setStatus] = useState(false);
  const [selectedRoute, setselectedRoute] = useState<ApplicationPeriod | null>(null);

  const [viewApplicationPeriodModal, setViewApplicationPeriodModal] = useState(false);
  const [editApplicationPeriodModal, setEditApplicationPeriodModal] = useState(false);

  const handleOpenEditApplicationPeriodModal = () => setEditApplicationPeriodModal(true);
  const handleCloseEditApplicationPeriodModal = () => setEditApplicationPeriodModal(false);
  const handleOpenViewApplicationPeriodModal = () => setViewApplicationPeriodModal(true);
  const handleCloseViewApplicationPeriodModal = () => setViewApplicationPeriodModal(false);

  const { data: allRoutesData } = FetchAllRoutes();
  const reOrderedAllRoutes = allRoutesData ? reOrderFetchedData((allRoutesData as RouteResponse).Data) : [];

  const DATA_PER_PAGE = 10;

  const handlePrevous = () => {
    if (currentPage > 0) setCurrentPage(prev => prev - 1);
  };

  const handleNext = () => {
    if (currentPage < pageArr.length - 1) setCurrentPage(prev => prev + 1);
  };

  const handleMore = (index: number) => {
    if (index === showIndex) {
      setShowIndex(null);
      setShowMore(false);
      return;
    }
    setShowIndex(index);
    setShowMore(true);
  };

  const handleSpan = (index: number) => {
    if (index === spanIndex) {
      setSpanIndex(null);
      setShowSpan(false);
      return;
    }
    setSpanIndex(index);
    setShowSpan(true);
  };

  const handleView = (data: ApplicationPeriod) => {
    setStartDate(stripDateString(convertTimetoString(data.StateDate, 0)));
    setEndDate(stripDateString(convertTimetoString(data.EndDate, 0)));
    setYear(data.Year);
    setStatus(data.Status);
    setRouteId(data.RouteId);
    handleOpenViewApplicationPeriodModal();
  };

  const handleUpdate = (data: ApplicationPeriod) => {
    setStartDate(stripDateString(convertTimetoString(data.StateDate, 0)));
    setEndDate(stripDateString(convertTimetoString(data.EndDate, 0)));
    setYear(data.Year);
    setStatus(data.Status);
    setRouteId(data.RouteId);
    setselectedRoute(data);
    handleOpenEditApplicationPeriodModal();
  };

  useEffect(() => {
    if (data && data.Data?.length > 0) {
      setActiveData(data);
      const lastPage = Math.ceil(data.Data.length / DATA_PER_PAGE);
      setPageArr(Array.from({ length: lastPage }, (_, i) => i));
      setPageData(data.Data.slice(0, DATA_PER_PAGE));
    }
  }, [data]);

  useEffect(() => {
    if (activeData && activeData.Data?.length > 0) {
      const start = currentPage * DATA_PER_PAGE;
      const stop = start + DATA_PER_PAGE;
      setPageData(activeData.Data.slice(start, stop));
    }
  }, [currentPage]);

  return (
    <div className={tableStyle.container}>
      <div style={{ gridTemplateColumns: `repeat(5, 2.3fr) 0.2fr` }}>
        <div>Route Name</div>
        <div>Start Date</div>
        <div>End Date</div>
        <div>Year</div>
        <div>Status</div>
      </div>
      <div>
        {pageData && pageData.length > 0 && pageData.map((data: ApplicationPeriod, index: number) =>
          <div key={index} style={{ gridTemplateColumns: `repeat(5, 2.3fr) 0.2fr` }}>
            <div onClick={() => handleSpan(index)}>{filterRouteName(data.RouteId, reOrderedAllRoutes)}</div>
            <div onClick={() => handleSpan(index)}>{stripDateString(convertTimetoString(data.StateDate, 0))}</div>
            <div onClick={() => handleSpan(index)}>{stripDateString(convertTimetoString(data.EndDate, 0))}</div>
            <div onClick={() => handleSpan(index)}>{data.Year}</div>
            <div onClick={() => handleSpan(index)}>{data.Status ? 'Active' : 'Inactive'}</div>
            <div>
              <span
                className={`${tableStyle.moreSpan} ${index === showIndex ? `${tableStyle.activeMore}` : ''}`}
                onClick={() => handleMore(index)}
              >
                <MoreIcon />
                {index === showIndex && showMore && (
                  <div>
                    <div onClick={() => handleView(data)}>View Details</div>
                    <div onClick={() => handleUpdate(data)}>Edit Period</div>
                  </div>
                )}
              </span>
            </div>
          </div>
        )}
      </div>
      <div className={tableStyle.pagination}>
        <div>
          <button className={`${tableStyle.lBtn} ${tableStyle.btn}`} onClick={handlePrevous}><LBtn /></button>
          {pageArr && pageArr.map((ePage: number) => (
            <span
              key={ePage}
              onClick={() => setCurrentPage(ePage)}
              style={ePage === currentPage ? { backgroundColor: "var(--activeP-back)", color: "var(--white-color)" } : {}}
            >
              {ePage + 1}
            </span>
          ))}
          <button className={`${tableStyle.rBtn} ${tableStyle.btn}`} onClick={handleNext}><RBtn /></button>
        </div>
      </div>

      <SettingsModal
        open={viewApplicationPeriodModal}
        cancel={handleCloseViewApplicationPeriodModal}
        maxWidth='712px'
        header='Application Period Details'
        showrightIcon={false}
        content={
          <ApplicationPeriodDetails
            startDate={StateDate}
            endDate={endDate}
            status={status}
            year={year}
            routeId={routeId}
          />
        }
      />

     <SettingsModal
  open={editApplicationPeriodModal}
  cancel={handleCloseEditApplicationPeriodModal}
  maxWidth="712px"
  header="Edit Application Period"
  showrightIcon={false}
  content={
    <QueryClientProvider client={queryClient}>
     <UpdateApplicationPeriod
        RouteId={String(selectedRoute?.RouteId ?? "")}
        RouteName={selectedRoute?.RouteName ?? "N/A"} // ✅ Add this line
        StateDate={selectedRoute?.StateDate ?? ""}
        endDate={selectedRoute?.EndDate ?? ""}
        year={selectedRoute?.Year ?? new Date().getFullYear()}
        status={selectedRoute?.Status ?? false}
        route={selectedRoute?.RouteId ?? 0}
        periodId={selectedRoute?.ApplicationPeriodId ?? 0}
        handleClose={handleCloseEditApplicationPeriodModal}
      />
    </QueryClientProvider>
  }
/>
    </div>
  );
};

export default ApplicationPeriodTable;
